import TourPage from "@/components/TourPage";

export default function CompleteRwanda7Day() {
  return (
    <TourPage
      tourId="rwanda/complete-7-day"
      title="7-Day Complete Rwanda Tour"
      duration="7 Days / 6 Nights"
      price="Contact for price"
      image="/Visit-Rwanda.png"
      description="Experience the best of Rwanda with this comprehensive tour featuring gorilla trekking in Volcanoes National Park, chimpanzee tracking in Nyungwe Forest National Park, golden monkey trekking, and exploration of Lake Kivu's stunning scenery."
      itinerary={[
        {
          day: 1,
          title: "Kigali – Nyungwe National Park",
          description: "Begin your Rwanda adventure with a drive to Nyungwe National Park.",
          activities: [
            "Depart from Kigali and drive to Nyungwe National Park",
            "Visit the Royal Palace at Nyanza",
            "Visit the Butare National Museum",
            "Arrive at your Nyungwe accommodation in time for dinner"
          ],
          accommodation: "Nyungwe Top View Hotel or similar",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Nyungwe National Park",
          description: "Experience the incredible primate life in Nyungwe Forest.",
          activities: [
            "Chimpanzee tracking in Nyungwe Forest National Park",
            "Guided forest walks to spot black and white colobus monkeys"
          ],
          accommodation: "Nyungwe Top View Hotel or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Nyungwe – Lake Kivu",
          description: "Explore Nyungwe Forest and travel to Lake Kivu.",
          activities: [
            "Guided waterfall walk or canopy walk in Nyungwe Forest National Park",
            "Drive to Karongi on the shores of Lake Kivu"
          ],
          accommodation: "Cleo Lake Kivu Hotel or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Lake Kivu – Volcanoes National Park",
          description: "Experience Lake Kivu and travel to Volcanoes National Park.",
          activities: [
            "Morning boat ride on Lake Kivu",
            "Visit the Gorilla Guardian Village to learn about Rwanda's pre-colonial past"
          ],
          accommodation: "Virunga Inn Resort & SPA or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Gorilla Trekking",
          description: "The highlight of your Rwanda experience - gorilla trekking.",
          activities: [
            "Gorilla trekking in Volcanoes National Park",
            "Spend an hour with a family of mountain gorillas"
          ],
          accommodation: "Virunga Inn Resort & SPA or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Golden Monkey Trekking – Kigali",
          description: "Track golden monkeys and return to Kigali.",
          activities: [
            "Golden monkey trekking in Volcanoes National Park",
            "Return to Kigali for dinner and overnight"
          ],
          accommodation: "Radisson Blu Hotel or similar",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 7,
          title: "Kigali City Tour – Departure",
          description: "Explore Kigali before your departure.",
          activities: [
            "Kigali city tour",
            "Visit craft markets",
            "Visit genocide memorial",
            "Visit the museum",
            "Departure"
          ],
          meals: "Breakfast"
        }
      ]}
      inclusions={[
        "All park entrance fees and permits",
        "All activities, including gorilla trekking, chimpanzee tracking, and golden monkey trekking",
        "All taxes and VAT",
        "Professional driver guide",
        "All meals (breakfast, lunch, and dinner)",
        "All transportation and airport transfers (4x4 luxury vehicle)",
        "Accommodation for all nights"
      ]}
      exclusions={[
        "International flights (from/to home)",
        "Personal requirements apart from the included",
        "Government-imposed increase of taxes and/or park fees",
        "Personal items (souvenirs, travel insurance, visa fees, etc.)",
        "Tips"
      ]}
    />
  );
}
